// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5a87bc4c","290":"4ae1f3e8","400":"28878cb9","618":"ce8b0c0d","716":"c14effbe"}[chunkId] + ".chunk.js";
};